<script lang="ts">
  import { onMount } from 'svelte';
  import { getStr } from '../../../common/util';
  import Divider from '../../common/components/Divider.svelte';
  import RichRelavance from '../../home/component/RichRelavance.svelte';
  import BlogCommonContent from './BlogCommonContent.svelte';
  import BlogDetailPage from './BlogDetail/BlogDetailPage.svelte';
  import BlogDetailPrevNext from './BlogDetail/BlogDetailPrevNext.svelte';
  import BlogDetailTopSection from './BlogDetail/BlogDetailTopSection.svelte';
  import RelatedBlogPost from './RelatedBlogPost.svelte';

  const carousalTitle = getStr('extra.ampliance.blog.shopThisArticle');

  export let blogDetailData: any;
  export let blogCarousalData: any;
  onMount(()=>{
    console.log('Onmount is called ')
    BlogpageDetailsScriptGenerate();
  })
  function BlogpageDetailsScriptGenerate() {
    if (!blogDetailData) return;

    const existing = document.querySelector('script[type="application/ld+json"][data-blog-schema]');
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-blog-schema', 'true'); 

    const schema = {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      "mainEntityOfPage":{
        "@type":"WebPage",
        "@id":window.location.href,
      },
      "headline": blogDetailData?.title,
      "description": blogDetailData?.description,
      "image":blogDetailData?.image,
      "publisher": {
        "@type": "Organization",
        "name": "Extra",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.extra.com/_ui/responsive/theme-extra/images/logo-extra.png"
          }
       },
      "datePublished": blogDetailData?.date,
      "timeRequired": `PT${blogDetailData?.readTime}M` ,
      "articleSection": blogDetailData?.category[0].category,
    };
    script.text = JSON.stringify(schema,null,2);
    document.head.appendChild(script);
  }
</script>
<svelte:head>
    <meta name="title" content={blogDetailData?.title} />
    <meta name="description" content={blogDetailData?.description} />
</svelte:head>
<BlogCommonContent>
  <BlogDetailTopSection data={blogDetailData} />
</BlogCommonContent>
<BlogCommonContent addContentClass={true}>
  <BlogDetailPage {blogDetailData} />
</BlogCommonContent>
{#if blogCarousalData && blogCarousalData.length}
  <BlogCommonContent>
    <Divider />
  </BlogCommonContent>
  <BlogCommonContent addContentClass={true}>
    <section>
      <RichRelavance
        isProductCrousel={true}
        ProductCrouselData={{
          hits: blogCarousalData,
          strategyMessage: carousalTitle,
        }}
        pageData={{
          display: true,
          key: '',
        }}
      />
    </section>
  </BlogCommonContent>
{/if}
{#if blogDetailData && blogDetailData?.nextPost && blogDetailData?.prePost}
  {@const { nextPost, prePost } = blogDetailData}
  <BlogCommonContent>
    <BlogDetailPrevNext {nextPost} {prePost} />
  </BlogCommonContent>
{/if}
{#if blogDetailData && blogDetailData.relatedPost && blogDetailData.relatedPost.length}
  <BlogCommonContent>
    <RelatedBlogPost relatedBlog={blogDetailData.relatedPost} />
  </BlogCommonContent>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  :global {
    .rr_parent_item_container {
      padding: 0 !important;
      @include desktop-max-width {
        padding: 0 16px !important;
      }
    }
  }
</style>
